export const ENV_TARGET = process.env.NX_TASK_TARGET_TARGET as 'build' | 'serve' | undefined
export const ENV_CONFIGURATION = process.env.NX_TASK_TARGET_CONFIGURATION as 'dev' | 'test' | 'prod' | undefined

export const ENV_API_BASE_URL = import.meta.env.VITE_API_BASE_URL
